import { CircularProgress, Stack } from '@mui/material';
import CreditsSlider, { CreditsTier } from 'src/components/creditsSlider';
import { SubtleLinkButton } from './styles/index.styles';

const BagsStep = ({
  loading,
  bagTiers,
  effectiveBagId,
  busy,
  hasPremium,
  onSelect,
  onAddToCart,
  onClose,
  onBackToGoPro,
}: {
  loading: boolean;
  bagTiers: CreditsTier[];
  effectiveBagId?: string;
  busy: boolean;
  hasPremium: boolean;
  onSelect: (id: string) => void;
  onAddToCart: () => void;
  onClose: () => void;
  onBackToGoPro: () => void;
}) => {
  if (loading) {
    return (
      <Stack sx={{ alignItems: 'center', py: '28px' }}>
        <CircularProgress size={26} />
      </Stack>
    );
  }

  return (
    <Stack sx={{ width: 'fit-content', mx: 'auto' }}>
      {effectiveBagId && (
        <CreditsSlider
          compact
          tiers={bagTiers}
          selectedId={effectiveBagId}
          onSelect={onSelect}
          onAddToCart={onAddToCart}
          addingToCart={busy}
          onClose={onClose}
          ctaLabel="Buy now"
          asChild
        />
      )}
      {hasPremium && (
        <SubtleLinkButton
          disableRipple
          onClick={onBackToGoPro}
          sx={{ alignSelf: 'center', py: '14px' }}
        >
          ← Go for Pro
        </SubtleLinkButton>
      )}
    </Stack>
  );
};

export default BagsStep;
